import { useState, useEffect } from "react";

export function useSafePosition({ 
    initialTop, 
    initialLeft, 
    sourceWidth = 0, // Width of the element that triggers the positioning
    sourceHeight = 0, // Height of the element that triggers the positioning
    width = 0, // Width of the element being positioned
    height = 0, // Height of the element being positioned
    offsetTop = 0 // Optional offset to apply to the top position
}) {
  const [position, setPosition] = useState({ top: initialTop, left: initialLeft });

  useEffect(() => {
    function adjustPosition() {
      if (height === 0 || width === 0 || initialTop === undefined || initialLeft === undefined) {
        return;
      }
      
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let newTop = initialTop + offsetTop;
      let newLeft = initialLeft + sourceWidth / 2 - width / 2; // Center horizontally relative to source

      // Adjust horizontally
      if (newLeft + width > viewportWidth) {
        newLeft = Math.max(0, viewportWidth - width);
      }
      if (newLeft < 0) newLeft = 0;

      // Adjust vertically
      if (newTop + height > viewportHeight) {
        newTop = Math.max(0, viewportHeight - height);
      }
      if (newTop < 0) newTop = 0;

      setPosition({ top: newTop, left: newLeft });
    }

    adjustPosition();

    window.addEventListener("resize", adjustPosition);
    return () => window.removeEventListener("resize", adjustPosition);
  }, [initialTop, initialLeft, width, height]);

  return position;
}
